import { render, staticRenderFns } from "./CompanyEmployeeQuickAddDialog.vue?vue&type=template&id=099d4e5b"
import script from "./CompanyEmployeeQuickAddDialog.vue?vue&type=script&lang=js"
export * from "./CompanyEmployeeQuickAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports